import { actionGenerator, IReduxAction } from '../../utils/actions';
import { IDepositAccountState } from '../../reducers/depositAccount';

export const UPDATE_DEPOSIT_ACCOUNT_PAYMENT = 'DEPOSIT_ACCOUNT :: UPDATE_PAYMENT';

type TPayload = Omit<IDepositAccountState, 'recommendedPackagePaymentStatus' | 'paymentStatus'>;

export type TUpdateDepositAccountPaymentAction = IReduxAction<typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT, TPayload>;

export const updateDepositAccountPayment = actionGenerator<typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT, TPayload>(
  UPDATE_DEPOSIT_ACCOUNT_PAYMENT,
);
